import { stakeholderSetEditMode } from "../../../../actions/stakeholder-actions"
import buildViewFormActionButtonsWidgetContainer from "../../../common/build-view-form-action-buttons-widget-container"

export default buildViewFormActionButtonsWidgetContainer(
    stakeholderSetEditMode,
    "stakeholders",
    true
)
